import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

export interface LanguageState {
  language: string
}

const initialState: LanguageState = {
  language: localStorage.getItem(process.env.REACT_APP_MAIN_VARIABLE + '_LANGUAGE') || process.env.REACT_APP_LANGUAGE_DEFAULT || '',
}

export const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    changeLanguage: (state, action: PayloadAction<string>) => {
      state.language = action.payload
      localStorage.setItem(process.env.REACT_APP_MAIN_VARIABLE + '_LANGUAGE', action.payload)
    }
  },
})

// Action creators are generated for each case reducer function
export const { changeLanguage } = languageSlice.actions

// export default counterSlice.reducer